// 現在のキャンバスと同じ ID の Connect Note 記事を開く URL を構築する。
// 対象記事がまだ存在しない場合に Connect Note 側が既存キャンバス追加画面へ誘導できるよう、
// リファインメントキャンバスからの遷移であることをクエリで明示する。
import { isValidCanvasId } from "./canvas-id";

/**
 * 自サービス origin から Connect Note の origin を導出する。
 * ホスト名先頭の `refinement.` を `note.` に置換し、demo / prod を必ず同じ環境へ揃える。
 */
export function getConnectNoteOrigin(
  serviceOrigin: string | undefined
): string | null {
  const service = validateHttpOrigin(serviceOrigin);
  if (service === null) {
    return null;
  }
  const url = new URL(service);
  if (!url.hostname.startsWith("refinement.")) {
    return null;
  }
  url.hostname = `note.${url.hostname.slice("refinement.".length)}`;
  return url.origin;
}

/** 同じキャンバス ID の Connect Note 記事 URL を構築する。 */
export function buildConnectNoteArticleUrl(
  canvasId: string,
  serviceOrigin: string | undefined
): string | null {
  if (!isValidCanvasId(canvasId)) {
    return null;
  }
  const origin = getConnectNoteOrigin(serviceOrigin);
  if (origin === null) {
    return null;
  }
  const url = new URL(`/articles/${encodeURIComponent(canvasId)}`, origin);
  url.searchParams.set("fromCanvas", "1");
  return url.toString();
}

function validateHttpOrigin(value: string | undefined): string | null {
  if (value === undefined || value.trim().length === 0) {
    return null;
  }
  try {
    const url = new URL(value.trim());
    if (url.protocol !== "http:" && url.protocol !== "https:") {
      return null;
    }
    return url.origin;
  } catch {
    return null;
  }
}
